import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { AirlineIcon } from "@tenant/ui";
import styles from "./BenchmarkFlight.module.scss";
import { useBenchmarkFlight } from "./hook";

interface BenchmarkFlightProps {
  arrival: string;
  departure: string;
  flightNumber: string;
  marketingAirline: string;
  stops: number;
  totalDurationMinutes: number;
  isOutbound: boolean;
  destination: string;
}

export const BenchmarkFlight = ({
  arrival,
  departure,
  flightNumber,
  marketingAirline,
  stops,
  totalDurationMinutes,
  isOutbound,
  destination,
}: BenchmarkFlightProps) => {
  const [block, cn] = useModuleBEM(styles, "BenchmarkFlight");
  const { t } = useI18nContext();

  const { context } = useBenchmarkFlight({
    arrival,
    departure,
    totalDurationMinutes,
    destination,
  });

  const { departureTime, arrivalTime, durationString, titleInfoValues } =
    context;

  const titleInfoDate = isOutbound ? (
    <Trans
      i18nKey={"core-packages.benchmark.flightDetailsTitle.detailsOutbound"}
      values={titleInfoValues}
      components={[<span className={cn("highlight")} />]}
    />
  ) : (
    <Trans
      i18nKey={"core-packages.benchmark.flightDetailsTitle.detailsReturn"}
      values={titleInfoValues}
      components={[<span className={cn("highlight")} />]}
    />
  );
  return (
    <div className={block}>
      <div className={cn("top-row")}>
        <span className={cn("flight-info-date")}>{titleInfoDate}</span>
      </div>
      <div className={cn("middle-row")}>
        <p className={cn("flight-times")}>
          {departureTime} - {arrivalTime}
        </p>
        <p className={cn("flight-length")}>{durationString}</p>
      </div>
      <div className={cn("bottom-row")}>
        <div className={cn("flight-airline")}>
          <AirlineIcon airlineCode={marketingAirline} size="small" />
          <p className={cn("flight-airline-name")}>
            {marketingAirline} • {flightNumber}
          </p>
        </div>
        <p className={cn("flight-stops")}>
          {stops === 0
            ? t("stopDetails.nonstop")
            : t("stopDetails.stop", { count: stops })}
        </p>
      </div>
    </div>
  );
};
